import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizacionesService } from '@app/_services/organizaciones.service';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services/menu.service';
import { PublicacionesService } from '@app/_services/publicaciones.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { Ente } from '@app/_models/ente';
import { Categoria } from '@app/_models/categoria';
import { Idioma } from '@app/_models/idioma';
import { Noticia, NoticiaTraduccion } from '@app/_models/noticia';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import {
  AlertService,
  DepartamentosService,
  UsuariosService,
} from '@app/_services';
import {
  Recinto,
  RecintoTrad,
  Reserva,
  Sala,
  SalaTrad,
} from '@app/_models/recinto';
import { RecintosService } from '@app/_services/recintos.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Usuario } from '@app/_models';

@Component({
  selector: 'app-reservas-crear',
  templateUrl: './reservas-crear.component.html',
})
export class ReservasCrearComponent implements OnInit {
  lang;
  private translate: TranslateService;
  idOrg: string;
  idSala: number;
  idRecinto: number = 0;

  myReserva: Reserva = new Reserva();
  titulo: string = '';
  descripcion: string = '';
  fechaInicio: Date = new Date();
  fechaFin: Date = new Date();
  listaUsuariosReserva: Usuario[] = [];

  constructor(
    private recintosService: RecintosService,
    private idiomaService: IdiomasService,
    private organizacionService: OrganizacionesService,
    private usuariosService: UsuariosService,
    private menuService: MenuService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant(
      'recintos.cabecera_reservas'
    );
  }

  ngOnInit(): void {
    this.idOrg = this.route.snapshot.params['idorg'];
    this.idRecinto = this.route.snapshot.params['idrecinto'];
    console.log('IDRECINTO=' + this.idRecinto);
    this.idSala = this.route.snapshot.params['idsala'];
    this.fechaInicio = this.recintosService.getFechaInicioReserva();
    this.fechaFin = new Date(this.fechaInicio);
    this.fechaFin.setHours(this.fechaFin.getHours() + 1);
  }

  btnCrearReserva() {
    if (this.titulo.length <= 0 && this.descripcion.length <= 0) {
      this.alertService.warn(
        this.translateService.instant('recintos.validacionreserva')
      );
      return;
    }
    if (this.listaUsuariosReserva.length > 0)
      this.myReserva.idUser = this.listaUsuariosReserva[0].id;
    else {
      this.alertService.warn(
        this.translateService.instant('recintos.validacionreserva')
      );
      return;
    }
    console.log('Creando Reserva');
    this.myReserva.title = this.titulo;
    this.myReserva.description = this.descripcion;
    this.myReserva.start = this.fechaInicio;
    this.myReserva.end = this.fechaFin;
    this.myReserva.idRecinto = this.idRecinto;
    this.myReserva.idSala = this.idSala;
    this.myReserva.isConfirmada = true;

    this.recintosService
      .crearReserva(this.myReserva)
      .subscribe((resultCrear) => {
        console.log(resultCrear);
        if (!resultCrear.error) {
          this.alertService.success(
            this.translateService.instant('recintos.successreserva')
          );
          this.router.navigate([
            'reservas',
            {
              idorg: this.idOrg,
              idrecinto: this.idRecinto,
              idsala: this.idSala,
            },
          ]);
        } else {
          this.alertService.error(
            this.translateService.instant('recintos.errorreserva')
          );
        }
      });
  }

  getUsuariosSeleccionados(listaUsuarios) {
    console.log('Usuarios seleccionados');
    console.log(listaUsuarios);
    this.listaUsuariosReserva = listaUsuarios;
  }

  btnCancelar() {
    this.router.navigate([
      'reservas',
      { idorg: this.idOrg, idrecinto: this.idRecinto, idsala: this.idSala },
    ]);
  }
}
